import React from "react";
import { Route, Redirect } from "react-router-dom";
import Authorization from "../utility/authorization";
import { setTitle, setMetaDescription } from "./config";
import Application from "../containers/Application";

/**
 * If we have a logged-in user, redirect to the home page. Otherwise, display the component.
 */
const PublicRoute = ({ component: Component, meta, ...rest }) => {
  return (
    <Route
      {...rest}
      render={props => {
        if (Authorization.isLoggedIn()) {
          // redirect page based on user role
          const user = Authorization.getAuthUser();
          const redirectPage =
            user.roleId === 10 ? "/bid-list" : "/bookings/addnew";
          return <Redirect to={{ pathname: redirectPage }} />;
        }
        setTitle(meta && meta.title ? meta.title : "");
        setMetaDescription(meta && meta.description ? meta.description : "");
        return (
          <Application
            {...props}
            isLoggedIn={Authorization.isLoggedIn}
            auth={Authorization}
            component={Component}
          />
        );
      }}
    />
  );
};

export default PublicRoute;
